import { ProColumns } from "@ant-design/pro-table";
import { fileHttpUrl } from "@api/baseUrl";
import { DateRangeWithDisabled } from "@components/Common";
import { Input, Select } from "antd";
import React, { ReactNode } from "react";

const options = [{label: 'options1', value: 1}, {label: 'options2', value: 2}]


export const statusOptions = [
    {
        label: '调用成功',
        value: 2
    },
    {
        label: '调用失败',
        value: 3
    }
]

export const checkTypeOptions = [
    {
        label: '查询成功',
        value: 1
    },
    {
        label: '查无信息',
        value: 2
    },
    {
        label: '查询失败',
        value: 9
    }
]
export const valueEnum = {
    2: { text: '调用成功', status: 'Success' },
    3: { text: '调用失败', status: 'Processing' },
}
export const valueEnum1 = {
    1: { text: '查询成功', status: 'Success' },
    2: { text: '查无信息', status: 'Processing' },
    9: { text: '查询失败', status: 'Default' },
}
const valueEnumCharge = {
    0: { text: '不收费', status: 'Default' },
    1: { text: '收费', status: 'Sueecss' },
}

/**
 * 列表表格配置:
 *  自定义表格 CustomerDemo 和 antd 升级版组件 ProTableDemo 都可使用, 
 * */
export const columnsFn: (operate: Function) => ProColumns<any>[] = (operate) => {
    return [
       
        {
            title: '用户姓名',
            dataIndex: 'name',
        },
        {
            title: '身份证号',
            dataIndex: 'idCard',
        },
        {
            title: '调用结果',
            dataIndex: 'sendStatus',
            key: 'sendStatus',
            valueType: 'select',
            valueEnum,
            request: async () => statusOptions
        },
        {
            title: '查询结果',
            dataIndex: 'adCheckType',
            key: 'adCheckType',
            valueType: 'select',
            valueEnum: valueEnum1,
            request: async () =>  checkTypeOptions,
            // hideInSearch: true
        },
        {
            title: '调用时间',
            dataIndex: 'callTime',
            // valueType: 'dateTimeRange',
            valueType: 'dateRange',
            fieldProps: { },
            search: {
                transform: (value) => {
                    return {
                        startTime: value[0] ? value[0] + ' 00:00:00' : undefined,
                        endTime: value[1] ? value[1] + ' 23:59:59' : undefined
                    }
                },
            },
            renderFormItem: (props) => <DateRangeWithDisabled />,
            render: (text: any, record: any) => record.callTime,
        },
        
    ]
}
